import { Brand } from 'common';

export const currentBrand = (process.env.REACT_APP_WEBSITE_BRAND || 'df') as Brand;
export const integrationApiBaseUrl = process.env.REACT_APP_INTEGRATION_API_BASE_URL;
export const integrationApiBaseUrlLocal = process.env.REACT_APP_API_BASE_URL_LOCAL;
export const idpHint = process.env.REACT_APP_IDP_HINT;
export const apiGatewayConsumerName = 'vwfs-du-cpnl';
